import React from 'react';
import TranslateContext from './TranslateContext';

const withTranslate = Component => {
  const TranslateComponent = props => {
    return (
      <TranslateContext.Consumer>
        {translate => <Component {...props} translate={translate} />}
      </TranslateContext.Consumer>
    );
  };
  const displayName = Component.displayName || Component.name || 'Component';
  TranslateComponent.displayName = `${displayName}WithTranslate`;
  return TranslateComponent;
};

export default withTranslate;
